import {config} from "../config/config";

// The tokens of this tab. One's own session lives in localStorage (every tab); a «Смотреть как» session in
// sessionStorage (this tab only), so the administrator's own tabs keep working as before.
const FLAG = 'eci-impersonation';

const safe = (work, fallback = null) => {
  try {
    return work();
  } catch (e) {
    return fallback;
  }
};

export const isImpersonating = () => safe(() => sessionStorage.getItem(FLAG) === '1', false);

const store = () => (isImpersonating() ? sessionStorage : localStorage);

export const getAccessToken = () => safe(() => store().getItem(config.ACCESS_TOKEN));

export const getRefreshToken = () => safe(() => store().getItem(config.REFRESH_TOKEN));

export const setTokens = (accessToken, refreshToken) => safe(() => {
  store().setItem(config.ACCESS_TOKEN, accessToken);
  store().setItem(config.REFRESH_TOKEN, refreshToken);
});

// a «Смотреть как» session for this tab
export const startImpersonation = (accessToken, refreshToken) => safe(() => {
  sessionStorage.setItem(FLAG, '1');
  setTokens(accessToken, refreshToken);
});

// ends the session of this tab: a «Смотреть как» one, or (otherwise) one's own
export const clearTokens = () => safe(() => {
  const s = store();
  s.removeItem(config.ACCESS_TOKEN);
  s.removeItem(config.REFRESH_TOKEN);
  sessionStorage.removeItem(FLAG);
});
